// extracted by mini-css-extract-plugin
module.exports = {"contactOption":"ContactOption_contactOption__z4_Me","content":"ContactOption_content__zZDq9","link":"ContactOption_link__2KGpi","text":"ContactOption_text__sGKZS"};